<template>
    <section class="blog">
        <section class="blog__posts-container blog__posts-container--primary">
            <section class="blog__posts">
                <article
                    v-for="(post, index) in posts.slice(0, 5)"
                    v-if="post.post_preview || post.guid"
                    :data-wow-delay="index * 0.15 + 's'"
                    :style="hasLoadedMore ? 'visibility: visible;' : null"
                    class="blog__post wow fadeInUp"
                >
                    <div
                        v-if="post.post_date"
                        v-text="convertDate(post.post_date) + ' / '"
                        class="blog__post-date"
                    />
                    <div
                        v-if="post.date"
                        v-text="convertDate(post.date) + ' / '"
                        class="blog__post-date"/>
                    <div
                        v-if="post.category_list"
                        v-text="getCategoryNames(post.category_list)"
                        class="blog__post-category"
                    />
                    <div
                        v-if="post.categories"
                        v-text="getCategoryNames(post.categories)"
                        class="blog__post-category"
                    />
                    <a
                        v-if="post.post_title"
                        v-text="post.post_title"
                        :href="post.slug"
                        class="blog__post-heading"
                    />
                    <a
                        v-if="post.title"
                        v-text="decode(post.title.rendered)"
                        :href="post.slug"
                        class="blog__post-heading"
                    />
                    <div
                        v-if="getPostPreview(post)"
                        v-text="spliceContent(getPostPreview(post))"
                        class="blog__post-content"
                    />
                    <a
                        v-if="post.slug"
                        :href="post.slug"
                        class="blog__post-link"
                    >
                        Read More
                    </a>
                    <hr class="blog__post-hr">
                </article>
            </section>
            <div
                data-wow-delay="0.25s"
                ref="featuredPost"
                class="blog__post blog__post--featured"
            >
                <slot name="featured-post--primary"/>
            </div>
        </section>
        <slot/>
        <section class="blog__posts-container blog__posts-container--secondary">
            <section class="blog__posts blog__posts--secondary">
                <article
                    v-for="(post, index) in posts.slice(5)"
                    v-if="post.post_preview || post.guid"
                    :data-wow-delay="index * 0.15 + 's'"
                    :style="hasLoadedMore ? 'visibility: visible;' : null"
                    class="blog__post wow fadeInUp"
                >
                    <div
                        v-if="post.post_date"
                        v-text="convertDate(post.post_date)"
                        class="blog__post-date"
                    />
                    <div
                        v-if="post.date"
                        v-text="convertDate(post.date)"
                        class="blog__post-date"
                    />
                    <div
                        v-if="post.category_list"
                        v-text="getCategoryNames(post.category_list)"
                        class="blog__post-category"
                    />
                    <div
                        v-if="post.categories"
                        v-text="getCategoryNames(post.categories)"
                        class="blog__post-category"
                    />
                    <a
                        v-if="post.post_title"
                        v-text="post.post_title"
                        :href="post.slug"
                        class="blog__post-heading"
                    />
                    <a
                        v-if="post.title"
                        v-text="decode(post.title.rendered)"
                        :href="post.slug"
                        class="blog__post-heading"
                    />
                    <div
                        v-if="getPostPreview(post)"
                        v-text="spliceContent(getPostPreview(post))"
                        class="blog__post-content"
                    />
                    <a
                        v-if="post.slug"
                        :href="post.slug"
                        class="blog__post-link"
                        v-text="'Read More'"
                    />
                    <hr class="blog__post-hr">
                </article>
            </section>
            <div class="blog__post blog__post-featured_secondary">
                <slot name="featured-post--secondary"/>
            </div>
        </section>
        <div
            v-if="showLoadMore"
            class="blog__load-more-container"
        >
            <button
                @click="getPosts(false)"
                class="blog__load-more"
                v-text="buttonText"
            />
        </div>
    </section>
</template>

<script>
import he from 'he';
import axios from 'axios';
import moment from 'moment';

export default {
    name: 'BrandBlog',
    props: {
        buttonText: {
            type: String,
            required: true,
        },
        initialPosts: {
            type: Array,
            required: true,
        },
        categories: {
            type: Array,
            required: true,
        },
        featuredPosts: {
            type: Array,
        },
    },
    data() {
        return {
            currentPage: 1,
            posts: this.initialPosts,
            currentCategory: undefined,
            previousCategory: undefined,
            hasLoadedMore: false,
            showLoadMore: true,
            isSticky: false,
        };
    },
    computed: {
        categoryIDs() {
            const IDList = [];
            this.categories.forEach((category) => {
                IDList.push(category.ID);
            });
            return IDList;
        },
    },
    /* eslint-disable */
    methods: {
        intersect(entries) {
            const entry = entries.filter(({target}) => {
                return target === this.$refs.featuredPost;
            });

            if (entry[0].intersectionRatio < 0.1) {
                this.isSticky = true;
            } else {
                this.isSticky = false;
            }
        },
        decode(str) {
            return he.decode(str);
        },
        getPostPreview(post) {
            const previewSources = [
                post && post.post_preview,
                post && post.acf && post.acf.post_preview,
            ];

            const preview = previewSources.find((value) => {
                return typeof value === 'string' && value.trim().length > 0;
            });

            return preview || '';
        },
        spliceContent(postContent) {
            if (typeof postContent === 'string' && postContent.trim().length > 0) {
                return postContent
                    .split(' ')
                    .splice(0, 50)
                    .join(' ')
                    .concat('...')
                ;
            }

            return '';
        },
        getPosts(resetPageCount) {
            if (!this.hasLoadedMore) {
                this.hasLoadedMore = true;
            }

            if (resetPageCount === true) {
                this.currentPage = 1;
                this.showLoadMore = true;
            } else {
                this.currentPage += 1;
            }

            axios
                .get('/wp-json/wp/v2/blog', {
                    params: {
                        page: this.currentPage,
                        per_page: 12,
                        categories: this.currentCategory.toString(),
                    },
                })
                .then((response) => {
                    if (resetPageCount) {
                        this.posts = response.data;
                    } else {
                        this.posts.push(...response.data);
                    }

                    if (response.data.length < 12) {
                        this.showLoadMore = false;
                    }
                })
                .catch((error) => {
                    this.showLoadMore = false;
                });
        },
        getCategoryNames(categories) {
            if (categories) {
                const categoryNameList = [];
                categories.forEach((currentCategory) => {
                    this.categories.forEach((category) => {
                        if (currentCategory === category.ID) {
                            categoryNameList.push(this.decode(category.name));
                        }
                    });
                });

                return categoryNameList.join(', ');
            }

            return null;
        },
        convertDate(date) {
            return moment(date, 'YYYYMMDD').format('LL');
        },
        handleStickyPost(container, articleHeight, headerHeight) {
            const desktopMediaQuery = window.matchMedia('(min-width: 640px)');

            Array.prototype.forEach.call(container, (el, index)  => {
                const article = articleHeight[index];
                const isPrimaryContainer = index === 0;

                const updateStickyState = () => {
                    if (!desktopMediaQuery.matches) {
                        el.classList.remove('sticky');
                        el.classList.remove('postStatic');
                        return;
                    }

                    const containerElement = el.getBoundingClientRect();
                    const articleRect = article ? article.getBoundingClientRect() : null;
                    const containerReachedHeader = containerElement.top < headerHeight;
                    const reachedContainerBottom = articleRect &&
                        (containerElement.height + containerElement.top - articleRect.height) < headerHeight;

                    if (reachedContainerBottom) {
                        el.classList.remove('sticky');
                        el.classList.add('postStatic');
                    } else if (isPrimaryContainer || containerReachedHeader) {
                        el.classList.remove('postStatic');
                        el.classList.add('sticky');
                    } else {
                        el.classList.remove('sticky');
                        el.classList.remove('postStatic');
                    }
                };

                addEventListener('scroll', updateStickyState);
                addEventListener('resize', updateStickyState);
                updateStickyState();
            })
        },
    },
    created() {
        this.currentCategory = this.categoryIDs;
        this.previousCategory = this.categoryIDs;
    },
    mounted() {
        if (this.initialPosts.length < 12) {
            this.showLoadMore = false;
        };

        const headerHeight = 67;
        const postsContainer = document.querySelectorAll('.blog__posts-container');
        const articleContainer = document.querySelectorAll('.featured-article');

        this.handleStickyPost(postsContainer, articleContainer, headerHeight)
    },
};
</script>



// WEBPACK FOOTER //
// BrandBlog.vue?21db5c69